const OLIVE = '#3F4A31';
const OLIVE_DEEP = '#324021';
const OLIVE_INK = '#323A27';
const CREAM = '#FCFCF1';
const CREAM_WARM = '#F4F3E8';

export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  shadowXs: 'rgba(10, 13, 18, 0.07)',
  type: 'light',
  primary: {
    main: OLIVE,
    light: OLIVE,
    after: OLIVE_DEEP,
    hover: OLIVE_DEEP,
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#FFFFFF33',
    contrastText: '#22211F',
  },
  text: {
    brand: '#00579C',
    primary: '#011C32',
    secondary: '#7C8694',
    tertiaryLight: '#626D7C',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    footerbg:'#25272C',
    link:'#21A8FF',
    howsubtitle:'#7C8694',
    black:'#000000',
    benefitssubtitle:'#49515B',
    benefitsHeading: '#344420',
    heading: '#25272C'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    fill: OLIVE_DEEP,
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#011A30',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: OLIVE_INK,
    tableSubhead: '#F9F9F3',
    tableBorder: '#EDEEF1',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#F7F8F8',
    secondary: '#F5F3F0',
    light: '#FAFAFA',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#D7DBE0',
    offer: '#CCEDFC',
    stepperCompleted: '#081425',
    benefits:'#F4F7FB',
    stepcounter:'#0371F2',
    pricingbenefits: OLIVE,
    footerbackground:'#225C68',
    loginhome:'#F8F8F8',
    sectionCream: CREAM,
    sectionVeil: 'rgba(255, 255, 255, 0.5)',
    heroVeil: OLIVE_DEEP,
    heroVeilFade: 'rgba(50, 64, 33, 0)',
    footerLight: CREAM_WARM,
    footerDivider: '#E5E7E4',
    innerHero: OLIVE_INK,
    disclaimerBand: '#667850',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#CCEDFC',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#CFD1D1',
    heroCta: OLIVE,
    heroCtaHover: '#E9EDE1',
    benefitsCard: 'rgba(244, 243, 232, 0.4)',
    buttonTertiary: '#EDEEF1',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
